<template>
  <div  class="collapse">
    <div :style="headerColor" class="collapse-header" >
      <div class="header-slot">
        <dx-heading
          class="dx-margin-bottom--none"
          :size="titleSize"
          :color="titleColor">
            {{ formattedTitle }}
        </dx-heading>
        <slot name="left-header"></slot>
      </div>
      <div class="header-slot">
        <slot name="right-header"></slot>
        <dx-icon icon="chevron-circle-up" :class="iconClass" @click="toggle" @keyDown="toggle" />
      </div>
    </div>
    <transition name="collapse">
      <div v-if="open" :style="contentBackgroundColor" class="collapse-content">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronCircleDown, faChevronCircleUp } from '@fortawesome/free-solid-svg-icons';
import { propValidationService } from '../functions';

library.add(faChevronCircleDown, faChevronCircleUp);

const THEME_TYPES = [
  { key: 'blue' },
  { key: 'blue-semi-light' },
  { key: 'light' },
];

export default {
  name: 'dx-collapse',

  props: {
    title: String,
    isOpened: {
      type: Boolean,
      default: true,
    },
    theme: {
      default: 'blue',
      type: String,
      validator: propValidationService.buildValidator({
        validValues: THEME_TYPES.map((attr) => attr.key),
        errorMessage: 'You should inform a valid theme',
      }),
    },
  },

  data() {
    return {
      open: this.isOpened,
    };
  },

  computed: {
    formattedTitle() {
      return this.isLight ? this.title : this.title.toUpperCase();
    },
    isLight() {
      return this.theme === 'light';
    },
    isLightBlue() {
      return this.theme === 'blue-semi-light';
    },
    titleColor() {
      return this.isLight ? 'grey-dark-light' : 'white';
    },
    titleSize() {
      const sizes = {
        light: 'sm',
        'blue-semi-light': 'md',
        blue: 'lg',
      };
      return sizes[this.theme];
    },
    iconClass() {
      return ['collapse-icon', this.open ? 'open' : 'closed'];
    },
    headerColor() {
      const colors = {
        blue: '--dx-color--blue',
        'blue-semi-light': '--dx-color--blue-semi-light',
        'grey-semi-light': '--dx-color--grey-semi-light',
      };
      return `background-color: var(${colors[this.theme]});`;
    },
    contentBackgroundColor() {
      return this.isLightBlue ? 'background-color: var(--dx-color--white)' : 'background-color: var(--dx-color--grey-light);';
    },
  },

  methods: {
    toggle() {
      this.$emit('toggle', !this.open);
      this.open = !this.open;
    },
  },
};
</script>

  <style scoped lang="scss">
  .collapse {
    border: 1px solid var(--dx-color--grey-semi-light);
    margin-bottom: 20px;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }

  .collapse-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    cursor: pointer;
    color: var(--dx-color--white);
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    height: 30px;

    .header-slot {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .collapse-icon {
    width: 20px;
    height: 20px;
    border: 1px solid #aaa;
    background-color: var(--dx-color--blue-semi-light);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    margin-left: 16px;
  }

  .collapse-icon.open {
    transform: rotate(180deg);
  }

  .collapse-icon.closed {
    transform: rotate(0deg);
  }

  .collapse-content {
    padding: 10px;
  }
  </style>
